module.exports = __webpack_public_path__ + "static/opensans-bold-webfont-d390accbd3b25bcfe11737f3bbcf5fb0.woff";